angular.module('admin.subscribers', [
    'admin.subscribers.index',
    // 'admin.subscribers.add',
    'admin.subscribers.detail'
  ]);
  


// WEBPACK FOOTER //
// ./client/src/app/admin/subscribers/index.js